<script setup lang="ts">
import type { CmsElementSidebarFilter } from "@shopware-pwa/composables-next";
import SwProductListingFilters from "../../listing-filters/SwProductListingFilters.vue";
import { useProductListingFilter } from "@/composables/useProductListingFilter";

const { isActive } = useProductListingFilter();

defineProps<{
  content: CmsElementSidebarFilter;
}>();

const isLoading = ref(true);
const showFilters = computed(() => isActive.value);

onMounted(async () => {
  isLoading.value = false;
});
</script>
<template>
  <div class="sidebar-filter md:block !m-0"
  :class="{ 'hidden md:block': !showFilters }"
  >
    <div
      v-if="!isLoading"
      class="cust-accordion-wrap grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-0 sm:gap-x-8 lg:gap-0"
    >
      <SwProductListingFilters :content="content" />
    </div>

    <div v-else class="loading-skeleton space-y-4">
      <div v-for="i in 4" :key="i" class="space-y-3">
        <!-- Accordion header -->
        <div
          class="h-10 bg-gray-200 rounded animate-pulse flex items-center px-4"
        >
          <div class="w-24 h-4 bg-gray-300 rounded"></div>
        </div>
        <!-- Accordion content -->
        <div class="px-0 space-y-2">
          <div
            v-for="j in 3"
            :key="j"
            class="h-4 bg-gray-200 rounded animate-pulse"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.sidebar-filter {
  transition: max-height 0.3s ease-in-out;
  --content-height: 200px; /* This is a default value, will be updated by JS */
}
.cust-accordion-wrap {
  transition: opacity 0.3s ease;
}
</style>
